var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass(),attrs:{"onclick":"reverseMirror()"}},[(!_vm.inMirror)?_c('span',[_vm._v(" Reverse The Mirror ")]):(_vm.canComplete)?_c('span',[_vm._v(" Break The Mirror ")]):_c('span',[_vm._v(" Escape The Mirror ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }